import * as actionTypes from './actionType'

export const receiveDropDownValues = payload => ({
    type: actionTypes.receiveDropDownValuesType,
    payload
})

export const validateFields = payload => ({
    type: actionTypes.validateFieldsType,
    payload
})

export const clearValidation = payload => ({
    type: actionTypes.clearValidationType,
    payload
})

export const postCharity = payload => ({
    type: actionTypes.suggestCharityType,
    payload
})

export const changeEinPopUpStatus = payload => ({
    type: actionTypes.changePopUpStatusType,
    payload
})

export const addToSavedCharity = payload => ({
    type: actionTypes.addToSavedCharityType,
    payload
})

export const clearCharityList = payload => ({
    type: actionTypes.clearCharityListType,
    payload
})